import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {ImageAttacher, ImageAttacherConfig} from "./image_attacher";

export const imageAttacherLoader = function (options = {}) {
    componentLoader(componentConfig(ImageAttacher, ImageAttacherConfig.componentTypeKey, ImageAttacherConfig.baseHtmlClass), options);
};
